// import API from "../../../app/api";

// export const getCheckoutProcess = async (checkoutId, data) => {
//   try {
//     const res = await API.put(
//       `/checkout/${checkoutId}/process`,
//       data
//     );

//     if (res.data?.success) {
//       return res.data.data;
//     }

//     return null;
//   } catch (error) {
//     console.error("Checkout Process Error:", error);
//     return null;
//   }
// };


import API from "../../../app/api";

export const getCheckoutProcess = async (checkoutId, payload) => {
  try {
    const response = await API.put(
      `/checkout/${checkoutId}/process`,
      payload
    );
    if (response?.data?.success) {
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error(
      "Checkout Process Error:",
      error.response?.data || error.message
    );
    return null;
  }
};